module.exports = __webpack_public_path__ + "static/media/background_2.5508a07f.mp3";